/**
 * Opens the visitor's email client as a backup copy of the form submission.
 * The primary record is already saved to the database (which triggers an
 * automated "QUOTE REQUESTED" email to the office). This is a belt-and-
 * suspenders fallback that gives the visitor a chance to press Send from
 * their own inbox.
 *
 * Uses a hidden anchor + click so it does NOT navigate the current tab,
 * leaving the on-page success / thank-you state intact.
 */
export function openMailtoBackup(opts: {
  to?: string;
  subject: string;
  body: string;
}) {
  if (typeof window === "undefined") return;
  const to = opts.to ?? "office@texasmadeshade.com";
  const href = `mailto:${to}?subject=${encodeURIComponent(
    `QUOTE REQUESTED — ${opts.subject}`
  )}&body=${encodeURIComponent(opts.body)}`;
  try {
    const a = document.createElement("a");
    a.href = href;
    a.rel = "noopener";
    // Some browsers honor target=_self for mailto without navigating
    a.target = "_self";
    document.body.appendChild(a);
    a.click();
    a.remove();
  } catch {
    // Last-resort fallback
    window.location.href = href;
  }
}
